export default __webpack_public_path__ + "icon_wrench.1f06405c1ccca217f176d0ce45595487.svg";